import Across from 'assets/icons/Across';
import { useCancelPlannedObjectProfessionRateMutation } from '../api/mutations/generated/CancelPlannedObjectProfessionRate';
import { useGetObjectProfessionLazyQuery } from '../api/query/generated/GetObjectProfession';

interface Props {
  handleCancel: () => void;
  casingRateId: string;
  objectProfessionId: string;
}

const CancelChangeRate = (props: Props) => {
  const { handleCancel, casingRateId, objectProfessionId } = props;
  const [getObjectProfession] = useGetObjectProfessionLazyQuery();

  const [cancelRate] = useCancelPlannedObjectProfessionRateMutation({
    onCompleted: async () => {
      await getObjectProfession({
        variables: {
          input: {
            objectProfessionId,
          },
        },
      });
      handleCancel();
    },
  });

  const handleClick = async () => {
    if (!casingRateId) {
      handleCancel();
      return;
    }

    try {
      await cancelRate({
        variables: {
          input: {
            objectProfessionRateId: casingRateId,
          },
        },
      });
    } catch (error) {
      console.error('Failed to cancel rate:', error);
    }
  };

  return (
    <div className="flex gap-2 text-smena_red cursor-pointer self-start" onClick={handleClick}>
      <Across />
      Отменить изменение
    </div>
  );
};

export default CancelChangeRate;
